import React from 'react';
import KeepaLayout from 'components/Layout';
import ButtonKit from 'components/Button';
import { Grid, Typography } from '@material-ui/core';
import { CloudConnection } from 'iconsax-react';

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { error: null, errorInfo: null };
	}

	componentDidCatch(error, errorInfo) {
		// Catch errors in any components below and re-render with error message
		this.setState({
			error: error,
			errorInfo: errorInfo,
		});
		// You can also log error messages to an error reporting service here
	}

	render() {
		if (this.state.errorInfo) {
			return (
				<KeepaLayout
					isShadow={false}
					buttonComponent={<ButtonKit onClick={() => window.location.reload(true)}>تلاش مجدد</ButtonKit>}
				>
					<Grid
						id="mobile-view"
						container
						style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'white' }}
					>
						<Grid xs={12} item style={{ textAlign: 'center' }}>
							<CloudConnection size="80" color="red" />
							<Typography style={{ color: 'red', fontWeight: 700, fontSize: '20px', marginTop: '20px' }}>
								خطای نامعلوم
							</Typography>
						</Grid>
					</Grid>
				</KeepaLayout>
			);
		}
		// Normally, just render children
		return this.props.children;
	}
}

export default ErrorBoundary;
